export default {
    state: {
        loadingCount: 0
    },

    getters: {
        isLoading(state) {
            return state.loadingCount > 0
        }
    },

    mutations: {
        START_LOADING(state) {
            state.loadingCount++
        },
        STOP_LOADING(state) {
            state.loadingCount = Math.max(0, state.loadingCount - 1)
        }
    },

    actions: {
        startLoading({ commit }) {
            commit('START_LOADING')
        },
        stopLoading({ commit }) {
            commit('STOP_LOADING')
        }
    }
}
